// const CLOUD_NAME = "dkhcq4y8k";
// const UPLOAD_PRESET = "shopify_upload";

// async function uploadToCloudinary(file){

//     if(!file) return "";

//     const formData = new FormData();

//     formData.append("file", file);

//     formData.append("upload_preset", UPLOAD_PRESET);

//     const response = await fetch(

//         `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,

//         {
//             method:"POST",
//             body:formData
//         }

//     );

//     const data = await response.json();

//     if(data.error){

//         throw new Error(data.error.message);

//     }

//     return data.secure_url;

// }

window.addEventListener("load", function () {
     if (typeof ShopifyAPI === "undefined") {
        console.error("ShopifyAPI not found");
        return;
    }

    const originalAddItem = ShopifyAPI.addItemFromForm;

    ShopifyAPI.addItemFromForm = async function (form, callback, errorCallback) {

        const button = form.querySelector("[name='add']");
        const buttonText = button.querySelector(".btn__text");

        try {

            button.disabled = true;
            buttonText.innerHTML = "Uploading...";

            const [front, back, logo] = await Promise.all([

                uploadToCloudinary(
                    document.getElementById("frontDesign")?.files[0]
                ),

                uploadToCloudinary(
                    document.getElementById("backDesign")?.files[0]
                ),

                uploadToCloudinary(
                    document.getElementById("logoUpload")?.files[0]
                )

            ]);

            document.getElementById("frontDesignUrl").value = front;
            document.getElementById("backDesignUrl").value = back;
            document.getElementById("logoUploadUrl").value = logo;

            originalAddItem(form, callback, errorCallback);

        }
        catch (err) {

            console.error(err);

            alert(err.message);

            button.disabled = false;
            buttonText.innerHTML = "Add To Cart";

        }

    };

});

